import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router/index.js' // 导入路由实例
import 'element-plus/dist/index.css'

const app = createApp(App)
const pinia = createPinia()
app.use(router) // 注册路由
app.use(pinia)
app.mount('#app')
